import React from "react";

/** Header for an admin page (dark theme). */
export function AdminPageHeader({ overline, title, description, actions, testId }) {
  return (
    <header className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between" data-testid={testId}>
      <div>
        {overline && (
          <div className="text-[10px] uppercase tracking-widest text-accent mb-2">{overline}</div>
        )}
        <h1 className="font-serif text-3xl sm:text-4xl leading-tight">{title}</h1>
        {description && (
          <p className="mt-2 text-sm text-white/60 max-w-2xl">{description}</p>
        )}
      </div>
      {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
    </header>
  );
}

/** Card container styled for the dark admin theme. */
export function AdminCard({ children, className = "", ...rest }) {
  return (
    <div
      className={`rounded-2xl border border-white/10 bg-[#161A1E] shadow-[0_1px_0_rgba(255,255,255,0.02)_inset] ${className}`}
      {...rest}
    >
      {children}
    </div>
  );
}

/** Simple KPI tile for admin. */
export function AdminKpi({ label, value, hint, tone = "neutral", testId }) {
  const toneClass = {
    accent: "text-accent",
    success: "text-emerald-400",
    warning: "text-amber-400",
    danger: "text-rose-400",
    neutral: "text-white",
  }[tone] || "text-white";
  return (
    <AdminCard className="p-4" data-testid={testId}>
      <div className="text-[10px] uppercase tracking-widest text-white/50">{label}</div>
      <div className={`mt-2 font-mono text-2xl font-semibold ${toneClass}`}>{value}</div>
      {hint && <div className="mt-1 text-xs text-white/50">{hint}</div>}
    </AdminCard>
  );
}
